import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AnimatedText from 'react-animated-text-content';
import './mission.css';
import { ArrowDown } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Mission = () => {
  const missionContent = (
    <>
      <Container fluid className='missionContainer '>
        <Container className='mission-inner-container'>
          <Row className='row__nm'>
            <Col>
              <h1 className='mission__h1 '>
                <AnimatedText
                  type='words' // animate words or chars
                  animation={{
                    x: '200px',
                    y: '-20px',
                    scale: 1.1,
                    ease: 'ease-in-out',
                  }}
                  animationType='throw'
                  interval={0.09}
                  duration={1}
                  tag='p'
                  className='animated-paragraph'
                  includeWhiteSpaces
                  threshold={0.9}
                  rootMargin='20%'
                >
                  ABOUT US
                </AnimatedText>
              </h1>
              <p className='mission__p1'>
                Our collection features 10,000 NFTs that combine over 100+
                different traits to create a unique and desirable Kutee kitty.
                Each attribute rarity is displayed in your NFTs metadata,
                showing how many NFTs feature that specific attribute. Holding a
                kutee kitty is the right way to give your contribution to save
                the world, obviously is only the first step into a change that
                we'll be so big and all the mankind will benefit from this!
              </p>
            </Col>
          </Row>
          <Row className='row__nm'>
            <Col>
              <h1 className='mission__h1 '>
                <AnimatedText
                  type='chars' // animate words or chars
                  animation={{
                    x: '200px',
                    y: '-20px',
                    scale: 1.1,
                    ease: 'ease-in-out',
                  }}
                  animationType='throw'
                  interval={0.09}
                  duration={1}
                  tag='p'
                  className='animated-paragraph'
                  includeWhiteSpaces
                  threshold={0.9}
                  rootMargin='20%'
                >
                  OUR MISSION
                </AnimatedText>
              </h1>
              <p className='mission__p1'>
                Our earth was divinely designed to provide a beautiful ecology
                that would protect not just ourselves but every other species on
                the globe. But in recent years, a threat brought on by mankind
                itself—plastic waste—started to creep into our precious
                universe. Therefore, Kutee Kitty has decided to fight back and
                save the world.
              </p>
              <p className='mission__p1'>
                Our mission is to cleanse the entire planet, especially the
                ocean floor. To ensure health, safety, and food for all species,
                we work to keep our atmosphere balanced and clean the oceans.
                One truckload of trash enters the waters every minute, causing
                unfortunate effects of plastic on humans and marine life. It
                penetrates our society like a disease. So we have gathered a
                powerful team of passionate members, every single one of them
                helping to fight plastic pollution.
              </p>
              <p className='mission__p1'>
                As we all know, recycling preserves resources and the
                environment. We attempt to create usable items through the very
                environmentally-friendly technique of recycling plastic. You
                will be amazed by our non-polluting materials, like T-shirts,
                all made from recycled plastic.
              </p>
              <p className='mission__p1'>
                Our platform is an excellent opportunity for you to contribute
                to protecting the world and the oceans’ fauna and flora. We make
                a great investment in the sector of innovative materials. We
                will enhance the project with a sustainable way to reduce the
                consumption of traditional plastic. Moreover, we have a charity
                at Ocean Voyages Institute. Following this, our team offers to
                provide a free journey across the world to unleash the beauties
                of the world. For more details visit our website.{' '}
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );

  return <div>{missionContent}</div>;
};

export default Mission;
